// JsFromRoutes CacheKey 1333e966a90bc85e37731b57db340e92
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  check: /* #__PURE__ */ definePathHelper('get', '/status'),
}
